import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Helpers from "../base/Helpers";
import delegate from "delegate";
import serialize from "form-serialize";



const selectors = {
  automaticGift: 'automaticGift',
  popUpGift: 'popupGifts',
  giftModal: '#popupGiftsModal',
  giftModalForm: 'popupGiftsForm'
};


/**
 * =========
 * Handle check for gifts
 * * =========
**/

function checkAutomaticGift() {
  let scriptVariables = ''
  let discountGiftsCheck = ''
  let discountGiftsCheckValid = false
  if (!!Helpers.getCookie("discount_code")){
    discountGiftsCheck = Helpers.getCookie("discount_code").toLocaleLowerCase()
  }
  if (!!Helpers.getCookie("discount_response")){
    discountGiftsCheckValid = Helpers.getCookie("discount_response")
  }

  if (!!document.querySelectorAll('.auto-script-itendifier')) {
    document.querySelectorAll('.auto-script-itendifier').forEach(e=>{
      if(discountGiftsCheck.includes(e.getAttribute('data-identifier'))){
        scriptVariables = document.querySelector(`#automaticGift--${e.getAttribute('data-identifier')}`)
      }
      return scriptVariables
    })	
  }

  if (!!scriptVariables) {
    const variableJson = JSON.parse(scriptVariables.textContent);
    const automaticGiftId = variableJson.automatic_product.toString();
    let inCart = variableJson.in_cart;
    const identifier = variableJson.identifier;
    const orderMinValueReached = variableJson.order_min_value_auto_reached;

    
    // if found, we add automatic gift to cart
    let items = [{
      id: automaticGiftId,
      quantity: 1,
      properties: {
        "_auto_gift_id": automaticGiftId
      }
    }]
    handleRemovedGift(automaticGiftId)
    if (!!sessionStorage.getItem('giftWasRemoved')) {
      if (sessionStorage.getItem('giftWasRemoved') === automaticGiftId ) {
        inCart = true
      }
    }
    if(discountGiftsCheckValid === 'true' && orderMinValueReached === true ){
      if (!!discountGiftsCheck && discountGiftsCheck.includes(identifier) && inCart == false ) {
        addGiftsToCart(items)
      }
    } else {
      $.getJSON('/cart.js', function(cart) {
        cart.items.forEach((item) => {
          if (!!item.properties._auto_gift_id) {
            removeCartItems(item.properties._auto_gift_id)
          }
        })
      })
    }
  }else {
    $.getJSON('/cart.js', function(cart) {
      cart.items.forEach((item) => {
        if (!!item.properties._auto_gift_id) {
          if (!!item.properties._auto_gift_id) {
            removeCartItems(item.properties._auto_gift_id)
          }
        }
      })
    })
  }
}

function handleRemovedGift(id) {
  const giftsWrapper = document.querySelectorAll('.vicampo-cart__wrapper--gift')
  if (!!giftsWrapper) {
    giftsWrapper.forEach(gift=>{
      if(!!gift){
        const quantityRemove = gift.querySelectorAll('[data-action="decrease-quantity"]')
        if (!!quantityRemove) {
          quantityRemove.forEach(el=>{
            el.addEventListener('click', function (e) {
              if (!!e.target.getAttribute('data-is-gift') && !!id ) {
                if (e.target.getAttribute('data-is-gift') == id) {
                  sessionStorage.setItem("giftWasRemoved", id)
                }
              }
            })
          })
        }
      }
    })
  }
}
function checkIfAvailable(giftModal) {
  if (!!giftModal) {
    const giftModalItems = giftModal.querySelectorAll('.popup__product-item')
    giftModalItems.forEach(giftModalItem => {
      let giftAvailable = giftModalItem.getAttribute('data-product-available')
      if (giftAvailable == 'false') {
        giftModalItem.classList.add('product-oos-locked')
        giftModalItem.style.pointerEvents = "none";
      }
    })
  }
}

function checkPopupGift() {
  let scriptVariablesPopup = ''
  let discountGiftsCheckPupUpCValid = false
  let discountPupUpCheck = ''
  if (!!Helpers.getCookie("discount_code")){
    discountPupUpCheck = Helpers.getCookie("discount_code").toLocaleLowerCase()
  }
  if (!!Helpers.getCookie("discount_response")){
    discountGiftsCheckPupUpCValid = Helpers.getCookie("discount_response")
  }
  if (!!document.querySelectorAll('.popup-script-itendifier')) {
    document.querySelectorAll('.popup-script-itendifier').forEach(e=>{
    
      if(discountPupUpCheck.includes(e.getAttribute('data-identifier'))){
        scriptVariablesPopup = document.querySelector(`#popupGifts--${e.getAttribute('data-identifier')}`)
      }
      return scriptVariablesPopup
    })	
  }

  if (!!scriptVariablesPopup) {
    const variablesJson = JSON.parse(scriptVariablesPopup.textContent);
    const identifierPopUp = variablesJson.identifier;
    const orderMinValuePopUp = variablesJson.order_min_value_popup_reached;
    const modalId = variablesJson.modal_id ? variablesJson.modal_id : '';
    const form_id = variablesJson.form_id ? variablesJson.form_id : '';
    const giftModal = document.querySelector(`#${modalId}`);
    const giftForm = document.querySelector(`#${form_id}`);

    if (!!!giftModal || !!!giftForm) {
      return
    }

    if(discountGiftsCheckPupUpCValid === 'true' && orderMinValuePopUp === true ){
      if (!!discountPupUpCheck && discountPupUpCheck.includes(identifierPopUp)) {
        openGiftModal(giftModal)
      }
    }else {
      handleFormRemoveMin(discountGiftsCheckPupUpCValid,orderMinValuePopUp)
    }
    initializeForm(giftModal,giftForm, form_id)
    checkIfAvailable(giftModal)
  }else {
    handleFormRemoveMin(false,false)
  }

} 


function initializeForm(giftModal,giftForm,form_id ){
  
  if (!!!giftModal || !!!giftForm || !!!form_id) {
    return
  }

  // Handle maximum allowed checkboxes
  const maximumAllowed = parseInt(giftForm.dataset.maxSelect);
  if (!!giftForm.querySelectorAll('.popup__product-item')) {
    giftForm.querySelectorAll('.popup__product-item').forEach(elm => {
      elm.addEventListener('click', function () {
        if(!!elm.querySelector('input[type=checkbox]')){
          elm.querySelector('input[type=checkbox]').checked = !elm.querySelector('input[type=checkbox]').checked
          if (elm.querySelector('input[type=checkbox]').checked == false) {
            elm.querySelector('input[type=checkbox]').removeAttribute('checked')
          }   
          selectiveCheck()
        }
      })
    })
  }
  function selectiveCheck() {
    const checkedChecks = document.querySelectorAll(`#${form_id} input[type=checkbox]:checked`);
    if(!!document.querySelectorAll(`#${form_id} input[type=checkbox]`)){
      document.querySelectorAll(`#${form_id} input[type=checkbox]`).forEach(check =>{
        if(check.checked){
          check.parentNode.parentNode.classList.add('selected')
        }else {
          check.parentNode.parentNode.classList.remove('selected')
        }
      })
    }

    if (checkedChecks.length === maximumAllowed ){ 
      giftForm.classList.add('is-locked');
    } else {
      giftForm.classList.remove('is-locked');
    }
    if (checkedChecks.length > maximumAllowed ){
      giftForm.classList.add('is-locked');
    }
  }

// Handle the submit function
  var submmitted = false
  var modalButton = giftModal.querySelector('.add-gift-modal')
  if(!!modalButton){
    modalButton.addEventListener("click", function(e){
      if (submmitted === true) {
        if (!!modalButton) {
          modalButton.setAttribute('disabled', 'disabled');
          modalButton.classList.add('is-locked');
          return true;
        }
      }
      let popupGiftId = []
      if(!!document.querySelectorAll(`#${form_id} input[type=checkbox]:checked`)){
        document.querySelectorAll(`#${form_id} input[type=checkbox]:checked`).forEach(input=>{
          popupGiftId.push(input.value)
        })
      }
   
      handleFormSubmit(popupGiftId)
      submmitted = true
    });
  };
}

function handleFormSubmit(giftItemsArray) {
  let items = []
  // check if single gift or multiple
  giftItemsArray.forEach((id, index) => {
    items[index] = {
      id: id,
      quantity: 1,
        properties: {
          "_popup_gift_id": id
        }
    }
  });
 
  addGiftsToCart(items,'popup')
}
function handleFormRemoveMin(discountGiftsCheck, minReached) {
  if(!!!discountGiftsCheck || !!!minReached){
    $.getJSON('/cart.js', function(cart) {
      const cartItems = cart.items
      cartItems.forEach((item) => {
        if (!!item.properties) {
          let popUpId = item.properties._popup_gift_id
          if (!!popUpId) {
            removeCartItems(popUpId, true)
          }
        }
      })
    })
  }  
}
function handleFormRemove(discountGiftsCheck) {
  if(!!!discountGiftsCheck){
    $.getJSON('/cart.js', function(cart) {
      const cartItems = cart.items
      cartItems.forEach((item) => {
        if (!!item.properties) {
          let popUpId = item.properties._popup_gift_id
          if (!!popUpId) {
            removeCartItems(popUpId, true)
          }
        }
      })
    })
  }  
}

/**
 * =========
 * Utility functions
 * We pass in items as an array
 * * =========
**/

function addGiftsToCart(items,trigger) {
  let formData = {
    items: items
  };
  // Add items via helpers file
  Helpers.addCartItems(formData).then((response) => {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    if (response.status === 200) {
      if (trigger == 'popup') {
        sessionStorage.setItem("modalShown", 'shown')
      }
      window.location.reload();
    }
  });
}

function removeCartItems(variantId, removeSesstion) {
  Helpers.removeCartItem(variantId).then((response) => {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    if (response.status === 200) {
      if (removeSesstion === true) {
        sessionStorage.removeItem("modalShown")
      }
     window.location.reload();
    }
  });
}


/**
 * =========
 * Modals
 * * =========
**/

function openGiftModal(modal){
  let modalWasShown = sessionStorage.getItem("modalShown")
  if (modalWasShown != 'shown') {
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
  }
  // we check if we click outside the modal
  delegate(modal, 'click', function(e) {
    if (e.target === modal){
      closeGiftModal(modal)
    }
  }, false);

  // Check if we click close button
  delegate(modal, '[data-action="close-modal"]', 'click', function(e) {
    closeGiftModal(modal)
  }, false);
}

function closeGiftModal(modal){
  modal.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('is-locked');
  sessionStorage.setItem("modalShown", 'shown')
}



/**
 * =========
 * Listeners
 * * =========
**/
let discountCheck = 'false'
document.addEventListener("DOMContentLoaded", function () {
  checkAutomaticGift();
  checkPopupGift();
  if (!!Helpers.getCookie("discount_response")){
    discountCheck = Helpers.getCookie("discount_response")
   }
   handleFormRemove(discountCheck)
});

document.addEventListener('cart:rerendered', function(){
  checkAutomaticGift();
  checkPopupGift();
  if (!!Helpers.getCookie("discount_response")){
    discountCheck = Helpers.getCookie("discount_response")
   }
   handleFormRemove(discountCheck)
});
